import React from 'react'

interface SubContainerProps {
  children: React.ReactNode
}

const SubContainer: React.FC<SubContainerProps> = ({ children }) => (
  <div className='mx-auto px-3 sm:px-5 md:px-2 xl:max-w-6xl xl:px-2'>
    {children}
  </div>
)

export default SubContainer
